
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./chrome-messages.cjs.production.min.js')
} else {
  module.exports = require('./chrome-messages.cjs.development.js')
}
